import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import VideoPlayer from "./VideoPlayer";
import { supabase } from "../supabase";

function TVDisplay() {
  const [deviceId, setDeviceId] = useState();
  const [isAdopted, setIsAdopted] = useState(false);

  useEffect(() => {
    // Check initial adoption status
    let dId = crypto.randomUUID();
    if (!localStorage.getItem("deviceId")) {
      localStorage.setItem("deviceId", dId);
      setDeviceId(dId);
    } else {
      dId = localStorage.getItem("deviceId");
      setDeviceId(dId);
    }

    const checkAdoption = async () => {
      const { data, error } = await supabase
        .from("tv_devices")
        .select("*")
        .eq("device_id", dId)
        .single();

      console.log("Device check:", { deviceId, data, error });
      setIsAdopted(!!data);
    };

    checkAdoption();

    // Subscribe to changes
    const channel = supabase
      .channel("tv_devices")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "slide_config",
          filter: `device_id=eq.${dId}`,
        },
        (payload) => {
          setIsAdopted(!!payload.new);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [deviceId]);

  if (!isAdopted) {
    return (
      <div className="flex items-center justify-center h-screen bg-black">
        <div className="text-center">
          <QRCode
            value={`${window.location.origin}/adopt/${deviceId}`}
            size={256}
            level="H"
          />
          <p className="text-white mt-4">Scan to adopt this TV</p>
          <p className="text-gray-400">Device ID: {deviceId}</p>
        </div>
      </div>
    );
  }

  return <VideoPlayer deviceId={deviceId} />;
}

export default TVDisplay;
